import DefaultPackaging from "@/components/setup/DefaultPackaging.vue";

export default {
  path: "/config/defaultPackaging",
  name: "DefaultPackaging",
  component: DefaultPackaging,
  meta: {
    breadcrumb: "defaultPackaging"
  }
};
